import React from "react";

import { AdminRole } from "../../../../services/AdminUsersService";

import style from "./styles.module.scss";

interface Props {
  roles: AdminRole[];
}

export default function RoleTags({ roles }: Props) {
  if (roles.length === 0) {
    return <span className={`pgm-body-medium ${style.muted}`}>—</span>;
  }

  return (
    <span className={style.roleTags}>
      {roles.map((role) => (
        <span key={role.id} className={`pgm-label-large ${style.tag} ${style.tagRole}`}>
          {role.name}
        </span>
      ))}
    </span>
  );
}
